// action - state management
import { LOGIN, LOGOUT, REGISTER, SET_APP_USER, SET_APP_USER_LOADING } from './actions';
import { InitialLoginContextProps } from 'types/auth';
import { AppUser } from 'types/app-user';

// ==============================|| ACCOUNT REDUCER ||============================== //

/*interface AccountReducerActionProps {
  type: string;
  payload?: InitialLoginContextProps;
}*/
const initialState: InitialLoginContextProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  appUser: null,
  isHydratingAppUser: false
};

type AccountReducerActionProps =
  | { type: typeof REGISTER; payload: { user: InitialLoginContextProps['user'] } }
  | { type: typeof LOGIN; payload: { isLoggedIn: InitialLoginContextProps['isLoggedIn'], user: InitialLoginContextProps['user'] } }
  | { type: typeof SET_APP_USER; payload: { appUser: AppUser | null } }
  | { type: typeof LOGOUT }
  | { type: typeof SET_APP_USER_LOADING };



export default function accountReducer(state = initialState, action: AccountReducerActionProps) {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload!;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user } = action.payload!;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
        appUser: null,
        isHydratingAppUser: false
      };
    }
    case SET_APP_USER: {
      const { appUser } = action.payload!;
      return {
        ...state,
        appUser: appUser,
        isHydratingAppUser: false
      };
    }
    case SET_APP_USER_LOADING: {
      return {
        ...state,
        isHydratingAppUser: true
      };
    }
    default: {
      return { ...state };
    }
  }
}
